<template>
  <v-container
    fluid
    grid-list-lg
  >
    <div class="world-map-container">
      <div
        v-show="showMap"
        class="pa-4"
      >
        <div class="display-1 white--text mt-12 text-center">
          You visited {{ visitedCountries.size }} countries
        </div>

        <v-progress-linear
          class="mt-3"
          color="accent"
          :value="visitedCountries.size / 1.95"
        />
      </div>

      <world-map />
    </div>

    <the-pwa-install-banner />

    <v-btn
      fab
      fixed
      color="accent"
      bottom
      right
      @click="toggleMap"
    >
      <v-icon>
        {{ showMap ? 'mdi-view-list' : 'mdi-map' }}
      </v-icon>
    </v-btn>

    <v-layout
      v-show="!showMap"
      row
      wrap
    >
      <v-flex
        v-for="trip in myTrips.models"
        :key="`trip-${trip.id}`"
        xs12
        md6
        lg4
        xl3
      >
        <trip-card :trip="trip" />
      </v-flex>

      <v-flex
        v-if="!myTrips.length"
        xs12
        class="text-center title"
      >
        Hey you don't have any trip yet,
        click on the button at the top right and create one!
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import panzoom from 'panzoom'

import ThePwaInstallBanner from '@/components/ThePwaInstallBanner'
import TripCard from '@/components/TripCard'
import Trips from '@/models/Trips'
import WorldMap from '@/assets/images/world.svg'

export default {
  name: 'Trips',
  components: {
    ThePwaInstallBanner,
    TripCard,
    WorldMap
  },
  data () {
    return {
      myTrips: new Trips(),
      panInstance: null,
      showMap: false,
      visitedCountries: new Set()
    }
  },
  watch: {
    $currentUser (newVal) {
      if (newVal) {
        this.loadData()
      }
    }
  },
  mounted () {
    if (this.$currentUser) {
      this.loadData()
    }

    this.panInstance = panzoom(document.querySelector('#world-map'))
    this.panInstance.pause()
  },
  methods: {
    async loadData () {
      await this.myTrips.fetch({
        where: [
          [ `users.${this.$currentUser.id}`, '>', '' ]
        ]
      })

      this.myTrips.sort('startDate')

      const accent = this.$vuetify.theme.currentTheme.accent

      this.visitedCountries.clear()

      for (const trip of this.myTrips.models) {
        for (const country of trip.countries) {
          document.getElementById(country).style.fill = accent
          this.visitedCountries.add(country)
        }
      }
    },
    toggleMap () {
      this.showMap = !this.showMap
      if (this.showMap) {
        this.panInstance.resume()
      } else {
        this.panInstance.pause()
      }
    }
  }
}
</script>

<style lang="scss">
.world-map-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: linear-gradient(to bottom, #69b3e7 70%, #f5f5f5);

  svg {
    width: 100%;
    height: 100%;
    stroke: #69b3e7;
    stroke-width: 2;

    &:focus {
      outline: none;
    }

    path[data-id] {
      fill: lightgrey;
    }
  }
}
</style>
